import { NgModule } from '@angular/core';
// import { ForestFinderComponent } from './forest-finder/forest-finder.component';
import { RemovePuncPipe } from './forest-finder/remove-punc.pipe';
import { ForestsService } from './services/forests.service'
import { PermitsService } from './services/permits.service'
import { SharedModule } from '../shared/shared.module';
import { ForestsAdminService } from './admin/forests-admin.service'

@NgModule({
  declarations: [
    // ForestFinderComponent,
    RemovePuncPipe,
  ],
  exports: [
  ],
  imports: [SharedModule],
  providers: [
    ForestsService,
    ForestsAdminService,
    PermitsService
  ]
})
export class ForestsModule {}
